<div class="forgot__page">
  <div class="main--wrapper">
    <!-- Start Header Section -->
    <header>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="auth-section--logo">
              <a role="button" [href]="commonService.landingUrl">
                <img [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'"
                onerror="this.src='assets/images/logo.png';" class="cursor-pointer" alt="Logo">
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- End Header Section -->


    <!-- Start Login Box Section -->
    <div class="container">
      <form autocomplete="off" [formGroup]="resetForm">
        <div class="auth-box--wrapper position-relative">
          <div class="blueish-bg hide-background">
            <div class="shade upper"></div>
            <div class="shade lower"></div>
          </div>

          <div class="box-wrapper">
            <h3 class="auth-box--title" [ngClass]="{'mb-0': linkSent}">
              {{linkSent ? 'Check your email' : 'Reset password'}}
            </h3>

            <ng-container *ngIf="linkSent; else passwordResetForm">
              <div class="color--gray font-size-12 mt-10 mb-50 text-center" *ngIf="isPswdChanged">
                To <span class="font-weight-bold">{{emailSentOn}}</span> was sent an email with a link to restore your password
              </div>
              <div class="color--gray font-size-12 mt-10 mb-50 text-center" *ngIf="!isPswdChanged && newMessage">
                {{newMessage}}
              </div>
              <div class="text-center mb-55">
                <svg-icon name="email_sent"></svg-icon>
              </div>
              <div class="text-center">
                <button type="button" class="button large__button ghost__button font-size-18" (click)="backToLogin()">
                  <svg class="mr-2" width="25" height="24" viewBox="0 0 25 24" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.5 11.999H22.5H4.5Z" fill="var(--primary-color)" />
                    <path d="M4.5 11.999H22.5" stroke="var(--primary-color)" stroke-width="2" stroke-miterlimit="10"
                          stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11.5 5L4.5 12L11.5 19" stroke="var(--primary-color)" stroke-width="2" stroke-miterlimit="10"
                          stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span class="ml-2">Back to log in</span>
                </button>
              </div>
            </ng-container>

            <ng-template #passwordResetForm>
              <div class="auth-box-form--wrapper">
                <div class="form-group" [ngClass]="{'error-block': checkControlValid('USER_EMAIL') || error}">
                  <label class="font-size-20 mb-0">Enter your email</label>
                  <div class="font-size-12__imp mb-15 color--gray font-weight-normal">Please, enter your email. We will send you there a magic link for resetting password.</div>
                  <input id="forgot-user-email" type="text" formControlName="USER_EMAIL" placeholder="Enter your email"
                         class="input input__large input__blue" (change)="emailChange()"
                         [ngClass]="{'error-input': checkControlValid('USER_EMAIL') || error}" required>
                  <ng-container *ngIf="checkControlValid('USER_EMAIL') && !error">
                    <div *ngIf="!resetForm.get('USER_EMAIL')?.value" class="error-text">Email is required</div>
                    <div *ngIf="resetForm.get('USER_EMAIL')?.value" class="error-text">The email you entered isn’t correct. Please check your email.</div>
                  </ng-container>
                  <ng-container *ngIf="error">
                    <div class="error-text">{{error}}</div>
                  </ng-container>
                </div>
                <div class="mt-55">
                  <div class="row">
                    <div class="col-md-12 col-12 my-1" *ngIf="captchaVisible">
                      <re-captcha (resolved)="resolved($event)"></re-captcha>
                    </div>

                    <div class="col-md-5 col-12 my-1">
                      <button id="forgot-back-log-in-btn" type="button" (click)="backToLogin()" class="button w-100 large__button secondary__button">
                        <svg class="mr-2" width="25" height="24" viewBox="0 0 25 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.5 11.999H22.5H4.5Z" fill="var(--primary-color)" />
                          <path d="M4.5 11.999H22.5" stroke="var(--primary-color)" stroke-width="2" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M11.5 5L4.5 12L11.5 19" stroke="var(--primary-color)" stroke-width="2" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Back to log in
                      </button>
                    </div>
                    <div class="col-md-7 col-12 my-1">
                      <button id="forgot-new-password" type="button" class="button large__button primary__button w-100 font-size-18" (click)="resetPassword()">
                        Reset password
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>

        </div>
      </form>

      <div class="auth-box--footer">
        <div class="row">
          <div class="col-12">
            <span class="auth-box-footer--text">
              If you previously had an account at
            </span>
            <span class="color--blue font-weight-bold">
              www.internalvaluation.com
            </span>
            <span>, please </span>
            <a id="login-sign-up-link-2" [routerLink]="['/signup']"
               class="btn btn-link btn-link-primary color--blue font-weight-bold">
              SIGN UP
            </a>
            <span> for a new account.</span>
          </div>
        </div>
      </div>
    </div>
    <!-- End Login Box Section -->

  </div>
</div>
